const StopCardStates = {
    LOWER: 'StopCardStates.LOWER',
    PEEK: 'StopCardStates.PEEK',
    SHOW: 'StopCardStates.SHOW',
    HIDE: 'StopCardStates.HIDE',
}

export default StopCardStates
